<template lang="pug">
#sub-empresa-bloco-dados-contrato-originacao
    h2.mb-3.mt-3 {{ $t('mensagens.subEmpresaGestao.blocodadoscontratooriginacao.titulo') }}

    BlocoSkeletonDadosGerais(:carregando='carregandoDadosGerais')
        el-card(shadow='never', :body-style='{ padding: "16px" }')
            .bloco-dados-contrato-originacao__linha
                .bloco-dados-contrato-originacao-informacao
                    .bloco-dados-contrato-originacao-codigo-externo
                        h4 {{ $t('mensagens.subEmpresaGestao.blocodadoscontratooriginacao.codigoExterno') }}
                        el-tooltip(v-if='dados.codigoExterno', placement='top')
                            .codigo-externo--tooltip(slot='content') {{ tooltipCopiarCodigo }}
                            i.mdi.mdi-content-copy(
                                @click='copiarCodigoParaAreaTransferencia(dados.codigoExterno)'
                            )
                        i.el-icon-edit(
                            @click='atualizarModalCodigoExterno(true)'
                        )
                    p.codigo-externo--minificado {{ dados.codigoExterno ? dados.codigoExterno : '--' }}
                .bloco-dados-contrato-originacao-informacao
                    h4 {{ $t('mensagens.subEmpresaGestao.blocodadoscontratooriginacao.numeroContrato') }}
                    p {{ dados.numeroContrato }}
                    
                .bloco-dados-contrato-originacao-informacao(v-if='isUsuarioLDC && dados.subTradingNome')
                    h4 Trading
                    p {{ dados.subTradingNome }}

                .bloco-dados-contrato-originacao-informacao
                    h4 {{ $t('mensagens.subEmpresaGestao.blocodadoscontratooriginacao.cultura') }}
                    p {{ dados.materialNome }}

                .bloco-dados-contrato-originacao-informacao
                    h4 {{ $t('mensagens.subEmpresaGestao.blocodadoscontratooriginacao.safra') }}
                    p {{ dados.safraNome }}

            .bloco-dados-contrato-originacao__linha
                .bloco-dados-contrato-originacao-informacao
                        h4 {{ $t('mensagens.subEmpresaGestao.blocodadoscontratooriginacao.dataContrato') }}
                        p {{ this.usuarioLogado.ambienteLogado === 'PY' ? formatDate(dados.dataContrato) : dados.dataContrato }}
                .bloco-dados-contrato-originacao-informacao(
                    v-if='this.usuarioLogado.ambienteLogado !== "PY"'
                )
                    h4 {{ $t('mensagens.subEmpresaGestao.blocodadoscontratooriginacao.municipios') }}
                    p {{ dados.municipioNome }}

                .bloco-dados-contrato-originacao-informacao
                    h4 {{ $t(this.usuarioLogado.ambienteLogado === 'PY' ? 'mensagens.subEmpresaGestao.blocodadoscontratooriginacao.departamento' : 'mensagens.subEmpresaGestao.blocodadoscontratooriginacao.estado') }}
                    p {{ this.usuarioLogado.ambienteLogado === 'PY' ? dados.localidadeNivelUmNome : dados.estadoSigla }}

                .bloco-dados-contrato-originacao-informacao
                    h4 {{ $t('mensagens.subEmpresaGestao.blocodadoscontratooriginacao.volumeContratado') }}
                    p {{ dados.volumeContratado }}

                .bloco-dados-contrato-originacao-informacao
                    .informacao-volumes-contrato
                        el-tooltip(
                            :content='$t("mensagens.subEmpresaGestao.blocodadoscontratooriginacao.informacaovolumescontrato.somatorioVolumes")',
                            placement='top'
                        )
                            i.el-icon-info.volumes-contrato
                        .volumes
                            h4 {{ $t('mensagens.subEmpresaGestao.blocodadoscontratooriginacao.volumeAdicionado') }}
                            p {{ dados.volumeAdicionado }}

                .bloco-dados-contrato-originacao-informacao
                    .informacao-volumes-contrato
                        el-tooltip(
                            :content='$t("mensagens.subEmpresaGestao.blocodadoscontratooriginacao.informacaovolumescontrato.volumeDisponivel")',
                            placement='top'
                        )
                            i.el-icon-info.volumes-contrato
                        .volumes
                            h4 {{ $t('mensagens.subEmpresaGestao.blocodadoscontratooriginacao.volumeRestante') }}
                            p {{ dados.saldoRestante }}

    div(v-if='modalCodigoExternoVisivel')
        BlocoInserirCodigoExterno(
            :dados='dados',
            :dialogVisible='modalCodigoExternoVisivel',
            @fechar='atualizarModalCodigoExterno'
        )
</template>

<script>
import BlocoInserirCodigoExterno from '@/components/contratosOriginacao/SubEmpresaBlocoInserirCodigoExterno.vue';
import BlocoSkeletonDadosGerais from '@/components/contratosOriginacao/BlocoSkeletonDadosGerais.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'SubEmpresaBlocoDadosContratoOriginacao',
    components: {
        BlocoInserirCodigoExterno,
        BlocoSkeletonDadosGerais
    },

    props: {
        dados: {
            required: true,
            type: Object
        },
        carregandoDadosGerais: {
            required: true,
            type: Boolean
        }
    },

    data() {
        return {
            modalCodigoExternoVisivel: false,
            tooltipCopiarCodigo: 'Copie o código'
        };
    },

    computed: {
        ...mapGetters(['usuarioLogado']),
        isUsuarioLDC() {
            return this.usuarioLogado?.isLDCRevenda === true;
        }
    },

    methods: {
        formatDate(date) {
            return new Date(date).toLocaleDateString('pt-BR');
        },
        copiarCodigoParaAreaTransferencia() {
            this.tooltipCopiarCodigo = 'Copiado';
            navigator.clipboard
                .writeText(this.dados.codigoExterno)
                .then(() => {
                    setTimeout(() => {
                        this.tooltipCopiarCodigo = 'Copie o código';
                    }, 1000);
                })
                .catch(function (error) {
                    // eslint-disable-next-line no-console
                    console.error('Erro ao copiar o texto: ', error);
                });
        },

        atualizarModalCodigoExterno(value) {
            this.modalCodigoExternoVisivel = value;
        }
    }
};
</script>

<style lang="scss" scoped>
#sub-empresa-bloco-dados-contrato-originacao {
    .mb-3 {
        font-weight: bold;
        margin-bottom: 20px;
    }
    .bloco-dados-contrato-originacao__linha {
        display: grid;
        grid-template-columns: repeat(5, 1fr);

        h4 {
            font-weight: bold;
            color: var(--primary);
        }
    }

    .bloco-dados-contrato-originacao-codigo-externo {
        display: flex;
        align-items: center;
        gap: 5px;

        i {
            cursor: pointer;
        }

        i:hover {
            color: var(--primary);
            font-weight: bold;
        }
    }

    .bloco-dados-contrato-originacao-informacao {
        min-width: 180px;

        .informacao-volumes-contrato {
            display: flex;
            gap: 2px;
        }
        .codigo-externo--minificado {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        p {
            word-break: break-all;
            max-width: 180px;
        }
    }
    .el-card.codigo-externo.is-never-shadow {
        margin-top: 4px;
    }
}
.codigo-externo--tooltip {
    width: 90px;
    text-align: center;
}

i.el-icon-info.volumes-contrato {
    color: var(--secondary-font-color);
}
</style>
